module.exports = __webpack_public_path__ + "img/help.98f88a79.svg";